/* Newsletter popup — subscribe & get a discount code.
   Trigger: time delay or scroll depth. Frequency capped via localStorage.
   Submits the Shopify customer form over fetch so the success state (and the
   discount code) can be shown without a page reload; falls back to a normal
   form POST if fetch is unavailable or fails. */
(function () {
  var root = document.querySelector('[data-npop]');
  if (!root) return;

  var KEY_DISMISSED = 'sora:npop:dismissed';
  var KEY_SUBSCRIBED = 'sora:npop:subscribed';
  var panel = root.querySelector('.sora-npop__panel');
  var formState = root.querySelector('[data-npop-form-state]');
  var successState = root.querySelector('[data-npop-success]');
  var form = root.querySelector('form');
  var errEl = root.querySelector('[data-npop-error]');
  var opened = false, lastFocus = null;

  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  function suppressed() {
    // In the theme editor always show it, so the merchant can style it.
    if (window.Shopify && window.Shopify.designMode) return false;
    if (read(KEY_SUBSCRIBED)) return true;
    var t = parseInt(read(KEY_DISMISSED) || '0', 10);
    if (!t) return false;
    var days = parseInt(root.getAttribute('data-frequency'), 10);
    if (isNaN(days) || days <= 0) days = 14;
    return (Date.now() - t) < days * 86400000;
  }

  // "Show on mobile" off: CSS hides the dialog below 768px, so never open it
  // there, or the scroll lock below would freeze an invisible page.
  function hiddenHere() {
    return root.classList.contains('sora-npop--nomobile') &&
      window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function open() {
    if (opened || hiddenHere()) return;
    opened = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    // Force a style flush, then open synchronously. requestAnimationFrame is
    // throttled in background tabs — relying on it could leave the page
    // scroll-locked with an invisible dialog.
    void root.offsetHeight;
    root.classList.add('is-open');
    document.body.classList.add('sora-npop-lock');
    var focusable = root.querySelector('input[type="email"], [data-npop-close]');
    if (focusable && window.innerWidth >= 768) {
      try { focusable.focus({ preventScroll: true }); } catch (e) {}
    }
    document.addEventListener('keydown', onKey);
  }

  function close(remember) {
    if (!opened) return;
    opened = false;
    root.classList.remove('is-open');
    document.body.classList.remove('sora-npop-lock');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { if (!opened) root.hidden = true; }, 260);
    if (remember !== false) store(KEY_DISMISSED, String(Date.now()));
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab' || !opened) return;
    // keep tabbing inside the dialog
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function showSuccess() {
    store(KEY_SUBSCRIBED, '1');
    if (formState) formState.hidden = true;
    if (successState) successState.hidden = false;
    if (!opened) open();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-npop-close]')) { e.preventDefault(); close(); return; }
    var code = e.target.closest('[data-npop-code]');
    if (code) {
      var val = code.getAttribute('data-code') || '';
      var label = code.querySelector('.sora-npop__copy');
      var done = function () {
        if (!label) return;
        var old = label.textContent;
        label.textContent = 'Copied ✓';
        setTimeout(function () { label.textContent = old; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(val).then(done).catch(done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = val; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(ta); done();
      }
    }
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return; // let it post normally
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var email = form.querySelector('input[type="email"]');
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      if (email && !email.checkValidity()) { email.reportValidity(); return; }
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Signing you up…'; }

      // redirect:'manual' is the important part. Shopify answers this POST with
      // a 302, and following it made fetch reject even though the signup had
      // already been recorded server-side — which is what painted a false
      // "Something went wrong" a beat before the success panel appeared.
      // Not following the redirect means the request completes cleanly; any
      // response we get back at all (including an opaque redirect) means
      // Shopify accepted the address. Only a real network failure rejects.
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        redirect: 'manual',
        headers: { 'Accept': 'text/html' }
      })
        .then(function () { showSuccess(); })
        .catch(function () {
          if (errEl) { errEl.hidden = false; errEl.textContent = 'Something went wrong — please try again.'; }
        })
        .finally(function () {
          if (btn) { btn.disabled = false; if (btn.dataset.label) btn.textContent = btn.dataset.label; }
        });
    });
  }

  // A native (non-fetch) submit round-trips with ?customer_posted=true
  if (/[?&]customer_posted=true/.test(window.location.search)) { showSuccess(); return; }

  if (suppressed()) return;

  var trigger = root.getAttribute('data-trigger') || 'delay';
  if (trigger === 'scroll') {
    var pct = parseInt(root.getAttribute('data-scroll'), 10) || 35;
    var onScroll = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0 || ((window.pageYOffset / h) * 100) >= pct) {
        window.removeEventListener('scroll', onScroll);
        open();
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  } else if (trigger === 'exit') {
    document.addEventListener('mouseout', function handler(e) {
      if (e.clientY <= 0 && !e.relatedTarget) { document.removeEventListener('mouseout', handler); open(); }
    });
    // touch devices never fire exit-intent — fall back to a delay
    setTimeout(function () { if (!opened && !suppressed()) open(); },
      (parseFloat(root.getAttribute('data-delay')) || 6) * 1000 + 8000);
  } else {
    var delay = parseFloat(root.getAttribute('data-delay'));
    if (isNaN(delay)) delay = 6;
    setTimeout(open, delay * 1000);
  }
})();
